import { Component, ComponentFactoryResolver, ElementRef, QueryList, ViewChild, ViewChildren, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { LoadingComponent } from 'src/app/shared/components/loading/loading.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { DtmService } from 'src/app/services/dtm.service';
import { HeaderContent } from 'src/app/shared/model/headerContent';
import { NutritionTable } from 'src/app/shared/model/nutrition-table';
import { ShopWindowItem } from 'src/app/shared/model/shop-window-item';
import { ShopWindowManager } from 'src/app/shared/model/shop-window-manager';
import { CatalogService } from 'src/app/shared/services/catalog.service';
import { DiscountModalService } from 'src/app/shared/services/discount-modal.service';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { ShopWindowService } from 'src/app/shared/services/shop-window.service';
import { packageSuggestionModalDisplayLogService } from 'src/app/shared/services/packageSuggestionModalDisplayLog.service';
import { Dtm, getDtm } from 'src/app/shared/enum/dtm';
import { ShopWindow } from 'src/app/shared/model/shop-window';
import { DialogData } from 'src/app/shared/model/dialog-data';
import { DialogAlertComponent } from 'src/app/shared/components/dialog-alert/dialog-alert.component';
import { environment } from 'src/environments/environment';
import { SuggestionProductModalComponent } from 'src/app/shared/components/suggestion-product-modal/suggestion-product-modal.component';
import { OneClickPurchaseInfo } from 'src/app/shared/model/one-click-purchase-info';
import { OneClickPurchaseComponent } from 'src/app/shared/components/one-click-purchase/one-click-purchase.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ProductListing } from 'src/app/shared/model/product-listing';
import { SpecialMessage } from 'src/app/shared/model/special-message';
import { CarouselSwiperConsultaComponent } from 'src/app/shared/components/carousel-swiper-consulta/carousel-swiper-consulta.component';
import { CarouselSwiperComponent } from 'src/app/shared/components/carousel-swiper/carousel-swiper.component';
import { CustomerService } from 'src/app/shared/services/customer.service';
import { ProductService } from 'src/app/shared/services/product.service';

const PRODUCT_CLASSIFICATION = 'consulta-e-recuperacao-de-dividas';
const NEW_PRODUCT_CLASSIFICATION = 'novo-consulta-e-recuperacao-de-dividas';
const PLAN_CLASSIFICATION = 'plano-mensal';

@Component({
    selector: 'pme-consulta-shop-window',
    templateUrl: './consulta-shop-window.component.html',
    styleUrls: ['./consulta-shop-window.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class ConsultaShopWindowComponent {
  @ViewChild('balaoOneClickContainer', { read: ViewContainerRef, static: false })
  balaoContainer!: ViewContainerRef;
  balaoOneClickComponentRef: any = null;

  //Variáveis de conteúdo do Shop Window
  headerContent: HeaderContent;
  tableNutritionContent: NutritionTable;
  stackingOnePackageMessage: SafeHtml;
  legalNotes: Array<string> = [];
  productListing: ProductListing;
  packages: Array<ShopWindowItem> = [];
  plans: Array<ShopWindowItem> = [];
  packagesAndPlans: Array<ShopWindowItem> = [];

  // Variáveis de query params
  coupon: any;
  userId: any;
  businessId: any;
  ref: string;
  internalReference: any;
  checksum: any;
  checksumData: { ref: any; internalReference: any; cs: any; };
  isHybridPackage: boolean;
  typeSpecialMessage: string;
  trustConsultationData: any;
  // Controle do Switch
  selectedToggle: number = 0;

  classificationsGetted: number = 0;
  hasSelectedPackage: boolean;
  purchaseOrigin: string;
  submitting: boolean;
  sugestionModalDataProducts: any;
  openModalSuggestionFlag: any;

  oneClickPurchaseInfo: OneClickPurchaseInfo;
  stackingOnePackage: boolean;

  hasActivePlan: boolean = false;
  activePlanIdentifier: string = '';
  activePlanValue: number = 0;
  window: string;

  constructor(
    public catalogService: CatalogService,
    public packageSuggestionModalDisplayLogService: packageSuggestionModalDisplayLogService,
    private discountModalService: DiscountModalService,
    private route: ActivatedRoute,
    private router: Router,
    private sessionStorageService: SessionStorageService,
    public dtmService: DtmService,
    public dialog: MatDialog,
    private elementRef: ElementRef,
    private cookieService: CookieService,
    private shopWindowService: ShopWindowService,
    private resolver: ComponentFactoryResolver,
    private sanitizer: DomSanitizer,
    private customerService: CustomerService,
    private productService: ProductService
  ) {
    this.openDialogSpinner();
    this.window = sessionStorage.getItem("ab_plans_eligibility") === "true" ? "B" : "A";
    this.clearStorage();

    this.getParameters();

    this.dtmService.customLoaded([]);
    this.dtmService.pageLoaded(Dtm.MeuPacote, this.sessionStorageService.getIsLogged(), getDtm(Dtm.MeuPacote, PRODUCT_CLASSIFICATION));
    this.dtmService.sendPageLoadEvent();



    const validatedMitigation = this.sessionStorageService.getValidatedMitigation();

    this.getProducts(PRODUCT_CLASSIFICATION, validatedMitigation, (items: ShopWindowItem[], typeSpecialMessage: string, trustConsultationData: any) => {
      this.packages = items.filter(item => !item.disable);
      if (typeSpecialMessage) {
        this.trustConsultationData = trustConsultationData;
        this.typeSpecialMessage = typeSpecialMessage;
      }
      this.stackingOnePackage = this.packages.length !== items.length;
      this.classificationsGetted++;

      this.getProducts(PLAN_CLASSIFICATION, validatedMitigation, (items: ShopWindowItem[]) => {
        if (this.window === 'A') {
          this.packages.push.apply(this.packages, items);
        }
        this.plans = items;
        this.classificationsGetted++;
        this.checkCustomerPlan();
      });


      this.loadShopWindowContent();
    });
  }

  tryCloseDialogSpinner() {
    if (this.classificationsGetted === 2) {
      this.handleProductsLoadDtm(this.window === 'B' ? (this.selectedToggle === 0 ? this.plans : this.packages) : this.packages);
      this.closeDialogSpinner();
    }
  }

  handleProductsLoadDtm(packagesCurrent: ShopWindowItem[]) {

    this.dtmService.productsLoaded(
      packagesCurrent.map((plan) => (
        { 'classificationName': plan.product.classificationName, 'identifier': plan.product.identifier, 'totalValue': plan.totalValue }))
    );

    this.dtmService.customLoaded(['ProdImpression']);
    this.dtmService.ruleChange('ProdImpression');
    this.dtmService.sendPageLoadEvent('ProdImpression');

  }

  getProducts(classification: string, validatedMitigation: any, callback: (items: ShopWindowItem[], typeSpecialMessage: string, trustConsultationData: any) => void): void {
    this.catalogService
      .getProductsByClassification(classification, this.userId, validatedMitigation, this.coupon, this.businessId, this.checksumData, undefined, undefined, this.window)
      .subscribe(
        (shopWindow: ShopWindow) => {
          if (shopWindow.oneClickPurchaseInfo) {
            this.oneClickPurchaseInfo = shopWindow.oneClickPurchaseInfo;
            this.dtmService.sendSydleCustomEvent("compraComUmClique", {
              businessId: this.businessId || null,
              userId: this.userId || null,
              jorneyMappingEvent: "Compra com um clique disponível",
            });
          }
          callback(shopWindow.shopWindowItems, shopWindow.typeSpecialMessage, shopWindow.trustConsultationData);
        },
        (error) => {
          throw new Error(
            `Erro ao obter produtos da classificação ${classification}: ${error.message}`,
          );
        },
      );
  }

  clearStorage() {


    this.sessionStorageService.clearSessionStorage(['oneClickPurchase']);
    this.sessionStorageService.clearSessionStorage(['purchaseOrigin']);
    this.sessionStorageService.clearSessionStorage(['oneClickPurchaseData']);
  }

  getParameters() {
    this.getProvisioningParametersFromSessionStorage();

    this.route.queryParams.subscribe((params) => {
      this.coupon = params.coupon;
      if (this.coupon) {
        sessionStorage.setItem('coupon', this.coupon);
      }
      if (params.userId && params.businessId) {
        this.userId = params.userId;
        this.businessId = params.businessId;
        this.setProvisioningParametersOnSessionStorage();
      }

      if (params.redirectUrl) {
        sessionStorage.setItem('successRedirectUrl', params.redirectUrl);
      }

      // Obtem parametros de checksum
      if (params.cs) {
        if (params.ref) {
          try {
            // Obtem user e business id do parametro ref em base64
            this.ref = atob(params.ref);
            const [refUserId, refBusinessId] = this.ref.split(':');

            if (refUserId) {
              this.userId = refUserId;
            }
            if (refBusinessId) {
              this.businessId = refBusinessId;
            }
            this.setProvisioningParametersOnSessionStorage();
          } catch (err) { }

        }

        if (params.internalReference) {
          this.internalReference = params.internalReference;
        }

        this.checksum = params.cs;
        this.checksumData = {
          ref: this.ref,
          internalReference: this.internalReference,
          cs: this.checksum
        };

        // Remove query params
        this.router.navigate([], {
          queryParams: {
            'cs': null,
            'ref': null,
            'internalReference': null
          },
          queryParamsHandling: 'merge'
        });
      }
      if (params.ab_plans_eligibility) {
        sessionStorage.setItem("ab_plans_eligibility", params.ab_plans_eligibility);
        this.window = params.ab_plans_eligibility === "true" ? "B" : this.window;
      }
    });

    this.isHybridPackage = this.cookieService.get('subscriptionPlansType') ? true : false;
  }

  ngOnInit(): void {
    const validatedMitigation = this.sessionStorageService.getValidatedMitigation();

    this.discountModalService.discountModalConfig.subscribe((newDiscountModalConfig) => {
      try {
        let discountModalConfig = JSON.parse(newDiscountModalConfig);
        if (discountModalConfig && discountModalConfig.timeToActivateShopWindow) {
          setTimeout(() => {
            //Impede o cenário que o cliente navegou para o pagamento sem ter ficado os 30 segundos na vitrine
            if (this.router.url.indexOf('meu-pacote') > -1) {
              this.discountModalService.setReachedTheModalTime(true);
            }

          }, discountModalConfig.timeToActivateShopWindow * 1000);
          //verificar f5 comportamento do reachedTheTimeModal
        }
      } catch (err) { }

    });
  }

  setProvisioningParametersOnSessionStorage() {
    this.sessionStorageService.setUserIdAndBusinessId(this.userId, this.businessId);

    if (this.userId && this.businessId) {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  loadShopWindowContent() {
    this.shopWindowService.getShopWindow(this.window === "A" ? PRODUCT_CLASSIFICATION : NEW_PRODUCT_CLASSIFICATION).subscribe((shopWindow: any) => {
      let shopWindowManager = new ShopWindowManager(shopWindow);
      this.legalNotes = [...(shopWindowManager.legalNotes ?? [])];

      this.headerContent = shopWindowManager.header;
      this.tableNutritionContent = shopWindowManager.nutritionTable;
      let foundStackingOnePackageMessage = this.findSpecialMessage(shopWindowManager);
      this.stackingOnePackageMessage = foundStackingOnePackageMessage ? this.sanitizer.bypassSecurityTrustHtml(foundStackingOnePackageMessage) : null;
      this.productListing = shopWindowManager.productListing;
    });
  }

  findSpecialMessage(shopWindowManagerObj) {
    //Caso especifico de consulta em confiança
    if (this.typeSpecialMessage === "consulta_em_confianca" && !this.trustConsultationData.error) {
      return this.trustConsultationData.message;
    }
    if (!shopWindowManagerObj.specialMessages.length) return false;
    return shopWindowManagerObj.specialMessages.find(msg => msg.type.name === 'empilhamento_de_saldo').message;
  }

  getProvisioningParametersFromSessionStorage() {
    this.userId = this.sessionStorageService.getUserId();
    this.businessId = this.sessionStorageService.getBusinessId();

    if (!this.userId || !this.businessId) {
      this.sessionStorageService.setIsLogged(false);
    } else {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  openDialogSpinner(): void {
    this.closeDialogSpinner();
    this.dialog.open(LoadingComponent, {
      disableClose: true,
      width: '400px',
      panelClass: 'pme-dialog-loading-panel',
      backdropClass: 'pme-dialog-loading-backdrop'
    });
  }

  @ViewChildren(CarouselSwiperComponent) swipersComuns!: QueryList<CarouselSwiperComponent>;
  @ViewChildren(CarouselSwiperConsultaComponent) swipersConsulta!: QueryList<CarouselSwiperConsultaComponent>;

  closeDialogSpinner() {
    this.dialog.closeAll();
  }


  onSelectionChanged(selectedIndex: number) {
    if (selectedIndex === this.selectedToggle) return;
    this.selectedToggle = selectedIndex;

    this.dtmService.customClickEvent(`Planos:Aba:${selectedIndex === 0 ? "PlanosPorAssinatura" : "PacotesDeCredito"}`)
    this.handleProductsLoadDtm(selectedIndex === 0 ? this.plans : this.packages)

  }

  handlePackageClick(i: number, autoClicked = false, mobile?: boolean) {

    let currPackages = []
    if (this.window === 'A') {
      currPackages = this.packages;
    } else {
      currPackages = this.selectedToggle === 0 ? this.plans : this.packages;
    }

    let selectedPackage = currPackages[i] ? currPackages[i] : null;

    if (!selectedPackage || selectedPackage?.disable) {
      const enableProducts = currPackages.filter(pckg => !pckg.disable);
      this.openErrorDialog('productDisabled', enableProducts, currPackages[i].product.identifier);
      this.sessionStorageService.setOneClickPurchase(false);
      this.sessionStorageService.setPurchaseOrigin('');
      return;
    }
    if (selectedPackage && selectedPackage.selected && selectedPackage === currPackages[i]) {
      selectedPackage.selected = false;
    }

    this.hasSelectedPackage = this.packages.some(pack => pack.selected === true);


    // Adobe Analytics
    if (!autoClicked) {
      this.discountModalService.setClickedOnPackages(true);
      this.dtmService.customLoaded(["ProdClick", "OverlayProdClick"]);
      this.dtmService.productsLoaded([{
        classificationName: selectedPackage.product.classificationName,
        identifier: selectedPackage.product.identifier
      }]);
      window.setTimeout(() => '', 500);
      this.dtmService.ruleChange('prodClick');
      this.dtmService.sendPageLoadEvent('prodClick');
    }

  }

  openErrorDialog(dialogData, enableProducts: ShopWindowItem[], productIdentifier) {
    const data = DialogData.fromPreset(dialogData, { enableProducts });
    const content = data.errorMessage;
    const errorDetail = data.errorDetail;

    this.dialog.open(DialogAlertComponent, {
      disableClose: dialogData === 'checksum' ? true : false,
      panelClass: 'pme-dialog-alert-panel',
      autoFocus: false,
      data: data
    });

    // Analytics
    this.dtmService.customErrorLoaded(['error'], {
      errorDetail: errorDetail || productIdentifier,
      errorMessage: content,
    });
  }

  navigate(i: number, customValue?: number) {
    let currentPackages = [];

    if (this.window === 'A') {
      currentPackages = this.packages;
    } else {
      currentPackages = this.selectedToggle === 0 ? this.plans : this.packages;
    }

    let product = currentPackages[i];

    if (this.purchaseOrigin !== 'oneClickPurchase' && product.suggestion && !this.isHybridPackage) {
      let productSuggestion = currentPackages.find(p => p.product.identifier === product.suggestion.suggestionProductIdentifier);

      if (!productSuggestion) {
        // this.handleSwiperPackageClick(i);
        return;
      };
      this.dtmService.pageLoaded(Dtm.ExibicaoModalSugestao, this.sessionStorageService.getIsLogged(), getDtm(Dtm.ExibicaoModalSugestao, PRODUCT_CLASSIFICATION));
      this.dtmService.userLoaded({
        "businessId": this.businessId || null,
        "userId": this.userId || null,
      });
      this.dtmService.suggestionEvent(productSuggestion.product.identifier, product.product.identifier);

      this.dtmService.sendSydleCustomEvent("modalDeSugestao", {
        "businessId": this.businessId || null,
        "userId": this.userId || null,
        "jorneyMappingEvent": "Modal de sugestão exibido"
      });

      if (!this.openModalSuggestionFlag) {
        this.esconderBalaoOneClick();
        let dialog = this.dialog.open(SuggestionProductModalComponent, {
          data: {
            product: product,
            suggestion: productSuggestion,
            sameProduct: product.product.identifier === product.suggestion.triggerProductIdentifier
          },
          panelClass: 'pme-suggestion-product-modal-panel',
          autoFocus: true,
          disableClose: false
        });
        this.openModalSuggestionFlag = true;
        dialog.afterClosed().subscribe((result) => {
          this.openModalSuggestionFlag = false;
          if (result?.approveSugestion) {
            this.packageSuggestionModalDisplayLogService.registerPackageSuggestion(this.userId, this.businessId, productSuggestion.product.identifier, true, product.suggestion.discountIdentifier).subscribe();
            this.handlePackageClick(currentPackages.indexOf(productSuggestion), false, false);
            this.dtmService.clicksModalSuggestion(productSuggestion.product.identifier, product.product.identifier, 'ACCEPTED');
            this.dtmService.pageLoaded(Dtm.ExibicaoModalSugestao, this.sessionStorageService.getIsLogged(), getDtm(Dtm.ExibicaoModalSugestao, PRODUCT_CLASSIFICATION));
            this.dtmService.userLoaded({
              "businessId": this.businessId || null,
              "userId": this.userId || null,
            });
            this.dtmService.sendSydleCustomEvent("modalDeSugestao", {
              "businessId": this.businessId || null,
              "userId": this.userId || null,
              "jorneyMappingEvent": "Sugestão acatada"
            });

            this.sessionStorageService.setPurchaseOrigin('suggestionPackageModal');
          } else {
            if (result?.approveSugestion === false) {
              this.packageSuggestionModalDisplayLogService.registerPackageSuggestion(this.userId, this.businessId, productSuggestion.product.identifier, false, product.suggestion.discountIdentifier).subscribe();

              this.handlePackageClick(currentPackages.indexOf(product), false, false);
              this.dtmService.clicksModalSuggestion(productSuggestion.product.identifier, product.product.identifier, 'REJECTED');
              this.dtmService.pageLoaded(Dtm.ExibicaoModalSugestao, this.sessionStorageService.getIsLogged(), getDtm(Dtm.ExibicaoModalSugestao, PRODUCT_CLASSIFICATION));
              this.dtmService.userLoaded({
                "businessId": this.businessId || null,
                "userId": this.userId || null,
              });
              this.dtmService.sendSydleCustomEvent("modalDeSugestao", {
                "businessId": this.businessId || null,
                "userId": this.userId || null,
                "jorneyMappingEvent": "Sugestão rejeitada"
              });
            } else {
              this.dtmService.clicksModalSuggestion(productSuggestion.product.identifier, product.product.identifier, 'CLOSED');
              this.dtmService.pageLoaded(Dtm.ExibicaoModalSugestao, this.sessionStorageService.getIsLogged(), getDtm(Dtm.ExibicaoModalSugestao, PRODUCT_CLASSIFICATION));
              this.dtmService.userLoaded({
                "businessId": this.businessId || null,
                "userId": this.userId || null,
              });
              this.dtmService.sendSydleCustomEvent("modalDeSugestao", {
                "businessId": this.businessId || null,
                "userId": this.userId || null,
                "jorneyMappingEvent": "Sugestão ignorada"
              });

              return;
            }
          }
          // Se existe uma targetURL no sessionStorage, usa-a pra navegar
          const targetUrl = sessionStorage.getItem('targetUrl');
          if (targetUrl && targetUrl !== '' && !targetUrl.includes('meu-pacote') && !targetUrl.includes('consulta-e-recuperacao-de-dividas') &&
            !targetUrl.includes('plano-mensal-recarga-pontual')) {
            this.router.navigate([targetUrl]);
          } else if (product.cardTitle === 'Plano Gratuito') {
            let baseURL = '';
            if (environment.production) {
              baseURL = 'https://www.serasaempreendedor.com.br/';
            } else {
              baseURL = 'https://valfenda-frontend-periscope-serasa-empreendedor-stg.apps.internal.appcanvas.net/';
            }
          } else if (!product.disable) {
            this.router.navigate(['../identificacao'], { relativeTo: this.route, queryParamsHandling: 'preserve' });
          }
          this.sessionStorageService.setProduct(product.product.identifier);
          this.sessionStorageService.setClassification(product.product.classificationIdentifier);
          this.sessionStorageService.setClassification(product.product.classificationName);
        });
        return;
      }

      this.dtmService.pageLoaded(Dtm.MeuPacote, this.sessionStorageService.getIsLogged(), getDtm(Dtm.MeuPacote, PRODUCT_CLASSIFICATION));
      return;
    }

    this.submitting = true;


    this.handlePackageClick(i, false, false);
    this.sessionStorageService.setProduct(product.product.identifier);
    this.sessionStorageService.setClassification(product.product.classificationIdentifier);
    this.sessionStorageService.setClassification(product.product.classificationName);

    // Se existe uma targetURL no sessionStorage, usa-a pra navegar
    const targetUrl = sessionStorage.getItem('targetUrl');
    // if (targetUrl && targetUrl !== '' && !targetUrl.includes('meu-pacote') && !targetUrl.includes('consulta-e-recuperacao-de-dividas') &&
    //   !targetUrl.includes('plano-mensal-recarga-pontual')) {
    //   this.router.navigate([targetUrl]);
    // } else {

    if (this.hasActivePlan && product.totalValue > this.activePlanValue && this.selectedToggle === 0) {

      const queryParams = {
        newPlan: product.product.identifier,
        businessId: this.sessionStorageService.getBusinessId(),
        userId: this.sessionStorageService.getUserId(),
        redirectUrl: window.location.href,
        returnUrl: window.location.href
      };

      const classification = this.sessionStorageService.getClassification();
      const url = '/auto-atendimento/plano-mensal/upgrade'

      this.router.navigate([url], { queryParams });
      return;
    }

    if (!product.disable) {
      const routeTarget = ['../identificacao'];

      let queryParams: any = {};
      if (this.productService.isVariableProduct(product.product)) {
        queryParams['customValue'] = customValue || 0;
      }
      this.router.navigate(routeTarget, { relativeTo: this.route, queryParams: queryParams });
    }


  }

  getSugestionModalData(products: Array<ShopWindowItem>) {

    products.forEach(product => {
      let productSuggestion = products.find(p => p.product.identifier === (product?.suggestion?.suggestionProductIdentifier ?? null));
      this.sugestionModalDataProducts.push({
        product: product,
        suggestion: productSuggestion,
        sameProduct: product.product.identifier === (productSuggestion?.product?.identifier ?? null)
      });
    });
  }

  criarBalaoOneClick(info: any, index: number, position: { top: number, left: number }) {
    this.balaoContainer.clear();

    const factory = this.resolver.resolveComponentFactory(OneClickPurchaseComponent);
    const componentRef = this.balaoContainer.createComponent(factory);
    this.balaoOneClickComponentRef = componentRef;

    componentRef.instance.show = true;
    componentRef.instance.oneClickPurchaseInfo = info;
    componentRef.instance.elementIndex = index;

    // Ajuste o estilo para posicionar o balão na tela
    const el = (componentRef.location.nativeElement as HTMLElement);
    el.style.position = 'fixed';
    el.style.top = position.top + 'px';
    el.style.left = position.left + 'px';
    el.style.zIndex = '9999'; // para garantir que fique por cima


    el.addEventListener('mouseleave', () => {
      this.esconderBalaoOneClick();
    });

    componentRef.instance.clickEvent.subscribe((event: any) => {
      this.onClickOneClickPurchase(event);
    });
  }

  esconderBalaoOneClick() {
    if (this.balaoOneClickComponentRef) {
      this.balaoOneClickComponentRef.instance.show = false;
      this.balaoContainer.clear();
      this.balaoOneClickComponentRef = null;
    }
  }

  onClickOneClickPurchase(event: { changePayment: boolean, elementIndex: number }) {
    this.sessionStorageService.setOneClickPurchase(true);
    this.sessionStorageService.setPurchaseOrigin('oneClickPurchase');

    //adobe analytics
    this.dtmService.customClickEvent('oneClickPurchase', `ProductSelected: ${this.packages[event.elementIndex].product.identifier} changePayment: ${event.changePayment}`);

    this.dtmService.sendSydleCustomEvent("compraComUmClique", {
      "businessId": this.businessId || null,
      "userId": this.userId || null,
      "jorneyMappingEvent": "Compra com um clique acatada"
    });

    let oneClickPurchaseData = {
      isDefaultCard: this.oneClickPurchaseInfo.isDefaultCard,
      name: this.oneClickPurchaseInfo.name,
      nickname: this.oneClickPurchaseInfo.nickname,
      isAdyen: this.oneClickPurchaseInfo.isAdyen,
      brand: this.oneClickPurchaseInfo.brand,
      accountPaymentDataId: this.oneClickPurchaseInfo.accountPaymentDataId,
      cardNumber: this.oneClickPurchaseInfo.cardNumber,
      situation: this.oneClickPurchaseInfo.situation,
      changePayment: event.changePayment
    }

    this.sessionStorageService.setOneClickPurchaseData(oneClickPurchaseData);
    this.navigate(event.elementIndex);
  }

  checkCustomerPlan(): void {
    if (!this.userId || !this.businessId) return;

    this.customerService.getContractStatusByProvisioningParameters(
      this.businessId,
      this.userId,
      'plano-mensal'
    ).subscribe({
      next: (res) => {
        if (res && res.success && (res.contractStatus === 'ACTIVE')) {
          let paramsToSave = "";
          this.route.queryParams.subscribe((params) => {
            if (paramsToSave === "") {
              paramsToSave += `?${Object.keys(params).map(key => `${key}=${params[key]}`).join('&')}`;
            } else {
              paramsToSave += `&${Object.keys(params).map(key => `${key}=${params[key]}`).join('&')}`;
            }
          });
          document.location.href = `/plano-mensal-recarga-pontual/checkout/meu-pacote${paramsToSave}`;

          // this.hasActivePlan = true;
          // this.activePlanIdentifier = res.product?.identifier;
          // const currentPlan = this.plans.find(p => p.product.identifier === this.activePlanIdentifier);
          // this.activePlanValue = currentPlan ? currentPlan.totalValue : (res.lastInvoice?.value || 0);

          // const maxPlanValue = Math.max(...this.plans.map(p => p.totalValue));
          // if (this.activePlanValue >= maxPlanValue) {
          //   this.selectedToggle =1;
          // }
        }
        this.tryCloseDialogSpinner();
      },
      error: () => {
        this.hasActivePlan = false;
      }
    });
  }
}
